import React, { useState } from 'react';
import {
    MapPin,
    Lock,
    Bell,
    CheckCircle,
    XCircle,
    AlertTriangle,
    Smartphone,
    UserCheck,
    FileText
} from 'lucide-react';

const AttendanceDemo = () => {
    // 模擬員工打卡數據
    const [attendanceStatus, setAttendanceStatus] = useState({
        isInRange: true,
        isDeviceVerified: true,
        hasAbnormalRecord: false
    });

    // 模擬打卡流程步驟
    const [currentStep, setCurrentStep] = useState(0);

    const attendanceSteps = [
        {
            title: 'GPS定位打卡',
            description: '確認打卡地點是否在公司指定範圍內',
            icon: <MapPin />,
            status: attendanceStatus.isInRange ? 'success' : 'error'
        },
        {
            title: '裝置指紋驗證',
            description: '使用FingerprintJS確認是否為註冊裝置',
            icon: <Lock />,
            status: attendanceStatus.isDeviceVerified ? 'success' : 'error'
        },
        {
            title: '異常檢測',
            description: '檢查是否有異常打卡記錄',
            icon: <Bell />,
            status: attendanceStatus.hasAbnormalRecord ? 'warning' : 'success'
        }
    ];

    // 模擬打卡操作
    const handleClockIn = () => {
        // 模擬打卡邏輯
        const newStatus = {
            isInRange: Math.random() > 0.2,
            isDeviceVerified: Math.random() > 0.1,
            hasAbnormalRecord: Math.random() < 0.15
        };

        setAttendanceStatus(newStatus);
        setCurrentStep(0);
    };

    return (
        <div className="p-8">
            <div className="grid md:grid-cols-2 gap-8">
                {/* 左側：打卡模擬介面 */}
                <div className="bg-gray-50 p-6 rounded-lg">
                    <h2 className="text-2xl font-bold mb-4 flex items-center">
                        <Smartphone className="mr-2 text-primary-600" />
                        GPS智能打卡
                    </h2>

                    <div className="mb-6">
                        <div className="flex items-center mb-4">
                            <UserCheck className="mr-2 text-primary-600" />
                            <span>王小明</span>
                        </div>
                        <div className="flex items-center mb-4">
                            <MapPin className="mr-2 text-primary-600" />
                            <span>台北市信義區 - 公司總部</span>
                        </div>
                        <div className="flex items-center">
                            <FileText className="mr-2 text-primary-600" />
                            <span>上班時間：09:00 AM</span>
                        </div>
                    </div>

                    <button
                        onClick={handleClockIn}
                        className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors"
                    >
                        立即打卡
                    </button>
                </div>

                {/* 右側：打卡流程步驟 */}
                <div>
                    <h3 className="text-xl font-semibold mb-4">打卡驗證流程</h3>

                    {attendanceSteps.map((step, index) => (
                        <div
                            key={step.title}
                            className={`flex items-center mb-4 p-4 rounded-lg ${index <= currentStep
                                    ? (step.status === 'success'
                                        ? 'bg-green-50 border-2 border-green-200'
                                        : step.status === 'warning'
                                            ? 'bg-yellow-50 border-2 border-yellow-200'
                                            : 'bg-red-50 border-2 border-red-200')
                                    : 'bg-gray-100'
                                }`}
                        >
                            {step.status === 'success' ? (
                                <CheckCircle className="mr-3 text-green-500" />
                            ) : step.status === 'warning' ? (
                                <AlertTriangle className="mr-3 text-yellow-500" />
                            ) : (
                                <XCircle className="mr-3 text-red-500" />
                            )}

                            <div>
                                <h4 className="font-semibold">{step.title}</h4>
                                <p className="text-sm text-gray-600">{step.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* 異常提醒區域 */}
            {attendanceStatus.hasAbnormalRecord && (
                <div className="mt-6 bg-red-50 border-2 border-red-200 p-4 rounded-lg flex items-center">
                    <AlertTriangle className="mr-3 text-red-500" size={24} />
                    <div>
                        <h4 className="font-semibold text-red-700">檢測到異常打卡</h4>
                        <p className="text-red-600">系統已記錄並通知主管進行審核</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AttendanceDemo;